import React, { useState, useImperativeHandle, forwardRef } from 'react';
import Button from '@material-ui/core/Button';
import Api from '../../../../__helpers/api'
import { useAuthDataContext } from '../../../../__providers/AuthProvider';
import { useHistory } from 'react-router-dom'

//images
import roadImg from '../../../../assets/images/profile/guide/1.png'
import videoImg from '../../../../assets/images/profile/guide/2.png'
import testsImg from '../../../../assets/images/profile/guide/3.png'
import examImg from '../../../../assets/images/profile/guide/4.png'
import topicTwoImg from '../../../../assets/images/profile/guide/tema-2.png'
import topicsImg from '../../../../assets/images/profile/guide/tema-18-19.png'
import licenseImg from '../../../../assets/images/profile/guide/5.png'
import rightArrowIcon from '../../../../assets/images/profile/right-arrow.png'
import leftArrowIcon from '../../../../assets/images/profile/left-arrow-blue.png'
import buttonPlay from '../../../../assets/images/profile/button-play.png'
import videoGuide from '../../../../assets/images/profile/video-guide.mp4'
import closeIcon from '../../../../assets/images/home/x.png'

//actions
import { refreshNotification } from '../../../../__actions/notifications'
import { handleModal } from '../../../../__actions/globalModals'

//dispatcher
import { useDispatch, useSelector } from 'react-redux'

let interval
let timeout
let partlyWatched

function Major(props, ref) {
    const auth = useAuthDataContext();
    let history = useHistory();
    const dispatch = useDispatch()

    const [major, setMajor] = useState({
        blur: false,
        popup: false,
        currentStep: 1,
        href: '',
        button: false,
        loaded: 0
    })

    const handleSlide = () => {
        if (major.currentStep == 5) {
            Api.post('student/hide-tutor')
            setTimeout(() => {
                history.push(major.href)
            }, 101);

            handleClose()
            return
        }
        setMajor(major => ({
            ...major,
            currentStep: major.currentStep == 5 ? 5 : major.currentStep + 1
        }))

        let guideSlides
        if (document.getElementsByClassName('guide-slider')) {
            guideSlides = document.getElementsByClassName('guide-slider')[0].children
        }

        if (major.currentStep < 5) {
            for (let i = 0; i < guideSlides.length; i++) {
                guideSlides[i].classList.remove('active')
                if (guideSlides[i].getAttribute('data-id') == major.currentStep + 1) {
                    guideSlides[i].classList.add('active')
                }
            }
        }
    }

    const handleBack = () => {
        setMajor(major => ({
            ...major,
            currentStep: major.currentStep == 1 ? 1 : major.currentStep - 1
        }))

        let guideSlides = document.getElementsByClassName('guide-slider')[0].children

        if (major.currentStep <= 5) {
            for (let i = 0; i < guideSlides.length; i++) {
                guideSlides[i].classList.remove('active')
                if (guideSlides[i].getAttribute('data-id') == major.currentStep - 1) {
                    guideSlides[i].classList.add('active')
                }
            }
        }
    }

    useImperativeHandle(ref, () => ({
        open: href => {
            handleOpen(href)
        },
        close: () => {
            handleClose()
        }
    }))

    const handleOpen = href => {
        document.querySelector('#video_html5_api') && document.querySelector('#video_html5_api').pause()

        setMajor(major => ({
            ...major,
            blur: true,
            href: href
        }))
        setTimeout(() => {
            setMajor(major => ({
                ...major,
                popup: true
            }))

            document.getElementById('videoGuide').play()

            timeout = setTimeout(() => {
                setMajor(prev => ({
                    ...prev,
                    button: true
                }))
            }, 27000)

            partlyWatched = setTimeout(() => {
                Api.post('student/hide-tutor?completed=1')
                    .then(() => {
                        dispatch(refreshNotification())
                    })
            }, 20000)

            interval = setInterval(() => {
                setMajor(prev => ({
                    ...prev,
                    loaded: prev.loaded + 2
                }))
            }, 500);
        }, 50);
    }

    const handleClose = () => {
        dispatch(handleModal('MAJOR_GUIDE', false, {}))

        setMajor(major => ({
            ...major,
            popup: false
        }))
        setTimeout(() => {
            clearInterval(interval)
            clearTimeout(timeout)
            clearTimeout(partlyWatched)
            document.getElementById('videoGuide').pause()

            document.getElementById('videoGuide').currentTime = 0

            setMajor(major => ({
                ...major,
                blur: false,
                currentStep: 1,
                button: false,
                loaded: 0,
            }))
            document.querySelector('#video_html5_api') && document.querySelector('#video_html5_api').play()
        }, 100);
    }

    const handleToVideos = () => {
        Api.post('student/hide-tutor')
            .then(() => {
                dispatch(refreshNotification())
            })

        setTimeout(() => {
            history.push(`/topic?topic_id=${auth.user.current_topic.current}&video_id=${auth.user.current_topic.current_video_id}`)
        }, 101);

        handleClose()
        // history.push(`/topic?topic_id=1&video_id=WSLzcGfv`)
    }

    return (
        <div id="overlay" className={major.blur ? 'visible' : ''}>
            <div className={`box guide video-guide ${major.popup ? 'show' : ''}`}>
                <img
                    src={closeIcon}
                    className="close"
                    alt="Затваряне"
                    title="Затваряне"
                    onClick={handleClose}
                />
                <h2>
                    Виж как работи Авто Обучение
                </h2>
                <video controls disablePictureInPicture id="videoGuide">
                    <source src={videoGuide} type="video/mp4" />
                </video>

                <div className="buttons">
                    <div className="row play-button-row">
                        <div className="loading-bar">
                            <div className="loading" style={{ width: major.loaded + "%" }}>

                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <Button onClick={handleToVideos} style={{ width: '270px' }}>
                            Към Видео Лекциите
                            <img src={buttonPlay} />
                        </Button>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default forwardRef(Major);